import { Link } from "react-router-dom";
import Logo from "../components/site/Logo";
import { BRAND } from "../lib/site";

const COPY = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Tricity Kroonerz respects your privacy. This page will soon carry our complete privacy policy.",
      "In the meantime, here is the short version: when you contact us through this website — by enquiry form, availability check, phone, WhatsApp or email — we use your name and contact details only to respond to your enquiry and plan your event. We do not sell, rent or share your information with third parties for marketing.",
      `Questions about your data? Write to us at ${BRAND.email}.`,
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "These terms govern the use of the Tricity Kroonerz website and enquiries made through it. Full terms will be published here shortly.",
      "Enquiries submitted through this website are requests for information and quotations — they are not confirmed bookings. Performance details, pricing and arrangements are finalized directly between you and Tricity Kroonerz.",
      "All performances are subject to availability and mutually agreed requirements. Every event is different; quotations are customized accordingly.",
      `For any questions, contact us at ${BRAND.email} or call/WhatsApp ${BRAND.phoneDisplay}.`,
    ],
  },
};

export default function Legal({ kind }) {
  const c = COPY[kind];
  return (
    <div className="min-h-screen bg-navy-950" data-testid={`legal-${kind}-page`}>
      <header className="border-b border-navy-700 px-4 py-4 sm:px-6">
        <div className="mx-auto flex max-w-3xl items-center justify-between">
          <Logo />
          <Link to="/" className="text-xs font-semibold text-slate-400 hover:text-gold" data-testid="legal-back-link">← Back to website</Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold">Tricity Kroonerz</p>
        <h1 className="mt-3 font-serif text-4xl font-bold text-ivory">{c.title}</h1>
        <div className="mt-8 space-y-5">
          {c.body.map((p, i) => (
            <p key={i} className="text-sm leading-relaxed text-slate-300 sm:text-base">{p}</p>
          ))}
        </div>
        <p className="mt-10 text-xs text-slate-500">Last updated: July 2026 · Chandigarh Tricity</p>
      </main>
    </div>
  );
}
